import { Component, Input } from '@angular/core';

import { isSituacaoAtivo, isSituacaoInativo } from '../item-tipo-situacao';

@Component({
    selector: 'sgt-item-tipo-situacao-badge',
    templateUrl: './item-tipo-situacao-badge.component.html',
    styleUrls: ['./item-tipo-situacao-badge.component.less']
})
export class ItemTipoSituacaoBadgeComponent {
    /** Situação do tipo de item */
    @Input() situacao: number;

    /** Verifica se a situação do tipo de item é Ativo */
    isSituacaoAtivo(): boolean {
        return isSituacaoAtivo(this.situacao);
    }

    /** Verifica se a situação do tipo de item é Inativo */
    isSituacaoInativo(): boolean {
        return isSituacaoInativo(this.situacao);
    }
}
